import React, { useState, componentDidMount, CSSProperties } from 'react';
import {
  MDBBtn, MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput,
  MDBCheckbox, MDBIcon, MDBCardImage
} from 'mdb-react-ui-kit';
// import '../../../node_modules/mdb-react-ui-kit/dist/css/mdb.min.css';
import { createContext } from 'react';
import { LANGUAGES, primary_theme_color, secondary_theme_color } from '../../../constants/constants';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCSRFInfo } from '../../system/redux/reducers/csrfReducer';
import { TextField } from '@mui/material';
import LoginForm from './loginForm';
import MultiSessionForm from './multiSessionForm';
import { useRefreshState } from '../../hooks/useRefreshState';
import '../../../styles/login.css';
import '../../ui-web/stateless/loginpage.css';
import loginBg from '../../../../src/assets/images/login-bg.jpg';
import LogoTwo from '../../../../src/assets/images/logo/logo-two.png';
import MJlogo from '../../../../src/assets/images/logo/mj.png'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import ResetPassword from './ResetPassword';
import MultiFactorAuthentication from './MultiFactorAuthentication';


function Login(props) {
  //Passing 1 to fetch all states
  const { i18n, t } = useTranslation();
  const [error, setError] = useState('');
  const [multiSession, setMultiSession] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [multiFactorAuthentication, setMultiFactorAuthentication] = useState(false);
  const navigate = useNavigate();
 
  const { param1} = useParams();
  useEffect(()=>{
    console.log(param1);
  },[param1])
  const onChangeLang = (e) => {
    const lang_code = e.target.value;
    i18n.changeLanguage(lang_code);
  };

  useEffect(() => {
    setTimeout(() => {
      console.log("error" + error);
      if (error.includes("CURRENT")) {
        setMultiSession(false);
      }
      else if (error.includes("multi") || error.includes("session")) {
        console.log('hello' + error);
        console.log('Wrong Credentials');
        console.log("Decoded Error Message: ", error);
        setMultiSession(true);
      }
      else if ((error.includes("Reset") && error.includes("Password") )|| (error.includes('Wrong old password entered'))) {
        console.log('hello' + error);
        console.log('Wrong Credentials');
        console.log("Decoded Error Message: ", error);
        setResetPassword(true);
      }
      else if(error.includes("log-in")){
        setResetPassword(false);
        setMultiFactorAuthentication(false);
      }
      else if(error.toUpperCase().includes("OTP")){
        if (error.includes("Maximum OTP regeneration limit reached. Please login and try again"))
        {
          setResetPassword(false);
          setMultiFactorAuthentication(false);
          // setMultiSession(false);
        }
        else{
          setMultiFactorAuthentication(true);
        setMultiSession(false);
        setResetPassword(false);
        }
          
      }
      else{
        setResetPassword(false);
        setMultiFactorAuthentication(false);
      }

    }, 1000);
  });

  // const handleCallback = (childData) => {
  //   setError(childData);
  // };
  const handleCallback = (childData) => {
    setError(childData);
    if (childData.includes("reset")) {
      setError("Reset-Password");
    }
  };

  useEffect(()=>{},[resetPassword])

  let LoginFormCard;
  if (multiSession) {
    LoginFormCard = <MultiSessionForm onErrorFromLogin={handleCallback} param={param1}/>;
  }
  else if(resetPassword){
    LoginFormCard = <ResetPassword onErrorFromLogin={handleCallback} />;
  }
  else if(multiFactorAuthentication){
    LoginFormCard = <MultiFactorAuthentication onErrorFromLogin={handleCallback} />;
  }
   else {
    LoginFormCard = <LoginForm  encoded={props.encoded} onErrorFromLogin={handleCallback} param={param1} />;
  } 



  return (

    <div className='login-area'>

      <div className='left-logo'>
        <img src={MJlogo}></img>
      </div>
      <div className='right-logo'>
        <img src={LogoTwo}></img>
      </div>

      {/* <MDBCol md='7'
          className='text-center text-md-start d-flex 
          flex-column justify-content-center' style={{marginTop:"10%"}}>

          <h1 className="my-5 display-3 fw-bold ls-tight px-3" style={{ color: 'hsl(218, 81%, 95%)', zIndex: '1'}}>
            {t('msg.login.page.first.heading')} <br />
            <span style={{ color: 'hsl(218, 81%, 75%)' }}>{t('msg.login.page.sec.heading')}</span>
          </h1>
          
          <p className='px-3' style={{ color: 'hsl(218, 81%, 85%)', textAlign: 'justify'}}>
            {t('msg.login.page.description')}
          </p>
         
        </MDBCol> */}
      <div className='form-signin m-auto'>
        <div className='text-center'>
          <h2 className='fw-bold mb-5'>{t("general.label.login")}</h2>
        </div>
        {/* <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
        <div id="radius-shape-2" className="position-absolute rounded-circle shadow-5-strong"></div> */}

        {/* <div className='flex'>
              <MDBCardImage tag='a'
                src="https://demofeedback.mjunction.in/cchp/resources/img/brand/mj-logo.png"
                style={{
                  marginLeft: '5%', marginBottom: 20, maxWidth: '40%',
                  borderRadius: '5px'
                }}>
              </MDBCardImage>
              <MDBCardImage tag='a'
                src="https://demofeedback.mjunction.in/cchp/resources/img/brand/turant-upay.png"
                style={{
                  marginLeft: '5%',
                  maxWidth: '50%', height: '3%', borderRadius: '5px'
                }}>
              </MDBCardImage>
            </div> */}



        {error &&
          <div className="alert alert-danger my-3">{error}</div>
        }
        {LoginFormCard}
        <Row className='justify-content-center'>
        <Col lg="auto" xs="auto" className='text-center mt-4'>
          <Form.Select defaultValue={i18n.language} onChange={onChangeLang}>
          {LANGUAGES.map(({ code, label }) => (
              <option key={code} value={code}>
                {label}
              </option>
            ))}
          </Form.Select>
          {/* <select defaultValue={i18n.language} onChange={onChangeLang}>
            {LANGUAGES.map(({ code, label }) => (
              <option key={code} value={code}>
                {label}
              </option>
            ))}
          </select> */}
        </Col>
        </Row>



      </div>

      {/* <img src={loginBg}></img> */}


      {/* <token.Provider value={ctoken}></token.Provider> */}
    </div>
  );
}

export default Login;